import { Body, Box, Divider, Heading, Stack } from "@biom3/react";
import Container from "@components/Container";

export type HeaderProps = {
  testId: string;
  title: string | JSX.Element;
  description?: string | JSX.Element;
  showDivider?: boolean;
  action?: React.ReactNode;
};

export function Header({
  title,
  description,
  testId,
  showDivider,
  action,
}: HeaderProps) {
  return (
    <Container testId={`${testId}__header`}>
      <Divider
        sx={{
          position: "relative",
          display: showDivider ? "flex" : "none",
        }}
      />
      <Stack
        direction={{
          default: "column",
          medium: "row",
        }}
        sx={{
          my: "base.spacing.x4",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Heading
            weight="bold"
            size="medium"
            testId={`${testId}__title`}
            sx={{ zIndex: 1, position: "relative" }}
          >
            {title}
          </Heading>
          {description ? (
            <Body
              size="small"
              weight="regular"
              color="base.text.secondary"
              testId={`${testId}__description`}
              sx={{ zIndex: 1, position: "relative" }}
            >
              {description}
            </Body>
          ) : null}
        </Box>
        {action && <Box sx={{ mt: "base.spacing.x1" }}>{action}</Box>}
      </Stack>
    </Container>
  );
}
